import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from "vuex";
import FormEditPage from "../../components/FormEditPage";
import CardItem from "@/pages/designCategory/components/CardItem";
import Title from "@/pages/designCategory/components/Title";
import ColorPicker from "@/pages/designCategory/components/ColorPicker";
import FileUpload from "@/pages/designCategory/components/FileUpload";
import InputBar from "@/pages/designCategory/components/InputBar";
export default {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    Title: Title,
    ColorPicker: ColorPicker,
    FileUpload: FileUpload,
    InputBar: InputBar
  },
  data: function data() {
    return {
      show: false,
      form: this.$form.createForm(this),
      rightIndex: 0 // 右侧选择的index
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.designCategory.imgHost;
    },
    rightCom: function rightCom(state) {
      return state.designCategory.select_simple_com;
    }
  })), {}, {
    list: function list() {
      if (!this.rightCom.image) return [];
      return [this.imgHost + this.rightCom.image];
    }
  }),
  watch: {
    rightCom: function rightCom() {
      if (!this.rightCom) {
        this.show = false;
        return;
      }
      this.show = true;
    }
  },
  methods: {
    handleImg: function handleImg() {
      this.rightCom.image = '';
    },
    handleImgSuccess: function handleImgSuccess(val) {
      this.rightCom.image = val;
    }
  }
};